import React, { FC, useCallback, useMemo } from 'react'

import { getFromLocalStorageDefValues } from 'shared/utils/getFromLocalStorage'
import { USERS_FILTER_STORAGE_NAME, USER_FILTER_INIT_VALUES, FILTER_FIELDS } from 'shared/consts/filter'
import { usersFiltersVar } from 'modules/Users/store'
import { formatUserFiltersParams } from 'shared/utils/filters'
import { FilterUsers } from 'modulesCommon/Filters/components'
import { useZonesList, useSpaces } from 'modulesCommon/serviceHooks'
import { useListUser, useRoles } from 'modules/Users/serviceHooks'

function zoneOptionsAdapter(data: { id: string, name: string }) {
  return {
    value: data?.id ?? '',
    label: data?.name ?? '',
    type: FILTER_FIELDS.LABELS
  }
}

function spacesOptionAdapter(space: { id: string, name: string, labels: { alias: string }[] }) {
  return {
    label: space.name,
    title: (space?.labels ?? []).map((label) => label?.alias ?? '').join(', '),
    value: space.id,
    type: FILTER_FIELDS.SPACES
  }
}

const FilterUsersContainer: FC = () => {
  const { zoneOptions } = useZonesList(zoneOptionsAdapter)
  const { total: usersTotal } = useListUser()
  const { rolesOptions } = useRoles()
  const { spacesOptions } = useSpaces(spacesOptionAdapter)

  const handleFilterEntities = useCallback((value: any) => {
    usersFiltersVar(formatUserFiltersParams(value))
    localStorage.setItem(USERS_FILTER_STORAGE_NAME, JSON.stringify(value))
  }, [])

  const initialValues = useMemo(
    () => getFromLocalStorageDefValues(USERS_FILTER_STORAGE_NAME, USER_FILTER_INIT_VALUES),
    []
  )

  return (
    <FilterUsers
      usersTotal={usersTotal}
      spaceOptions={spacesOptions}
      zoneOptions={zoneOptions}
      rolesOptions={rolesOptions}
      filterEntities={handleFilterEntities}
      initialValues={initialValues}
      defaultValue={USER_FILTER_INIT_VALUES}
    />
  )
}

export default FilterUsersContainer
